import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    title: string,
    color: string,
    contrastColor: string,
}

export default function Badge({title, color, contrastColor}: Props) {
    return (
        <View style={[styles.badge, {backgroundColor: color}]}>
            <Text style={[styles.text, {color: contrastColor}]} selectable={false}>
                {title}
            </Text>
        </View>
    )
}

export const styles = StyleSheet.create({
    badge: {
        backgroundColor: Color.Yellow,
        borderRadius: 4,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 5,
        paddingRight: 5,
        flexShrink: 1,
    },
    text: {
        color: Color.Background,
        fontSize: 12,
        fontWeight: 600,
    },
})